export default __webpack_public_path__ + "static/media/favicon.75a63bed.png";